import React                     from 'react';
import ReactDOM                  from 'react-dom';
import Segmented                 from '@widesk-ui/Segmented';
import SettingsButton            from '@/TokamapEditor/ux/AreaSidebar/SettingsPopover';
import useDesignTokens           from '@/hooks/useDesignTokens';
import { FieldLabelSlotContext } from '@/TokamapEditor/ux/AreaSidebar/Field';

const PREVIEW_SIZE = 24;
const PREVIEW_MAX_WIDTH = 4;

export default function BorderButton({ label = 'Bordure', summary, color, width, dashed, mixed, themed, children }: {
	label?: string;
	summary: string;
	color?: string;
	width?: number;
	dashed?: boolean;
	mixed?: boolean;
	themed?: boolean;
	children: React.ReactNode;
}) {
	const tokens = useDesignTokens();
	const previewWidth = Math.min(Math.max(width ?? 1, 1), PREVIEW_MAX_WIDTH);

	return (
		<SettingsButton
			label={label}
			summary={summary}
			mixed={mixed}
			themed={themed}
			preview={(
				<span
					style={{
						width: PREVIEW_SIZE,
						height: PREVIEW_SIZE,
						borderRadius: 4,
						flexShrink: 0,
						boxSizing: 'border-box',
						border: `${previewWidth}px ${dashed ? 'dashed' : 'solid'} ${color || tokens.border.default}`,
					}}
				/>
			)}
		>
			{children}
		</SettingsButton>
	);
}

export function StrokeWidthChoice({ options, value, unit, onChange }: {
	options: { label: string; value: number; }[];
	value?: number;
	unit: { value: string; options: { value: string; label: string; }[]; title: string; onChange: (value: string) => void; };
	onChange: (value: number) => void;
}) {
	const tokens = useDesignTokens();
	const slot = React.useContext(FieldLabelSlotContext);
	const selected = value === undefined ? undefined : options.find(option => Math.abs(option.value - value) < 1e-6)?.value;

	const unitSelect = (
		<select
			aria-label="Unité"
			title={unit.title}
			value={unit.value}
			onChange={e => unit.onChange(e.target.value)}
			style={{
				border: 0,
				padding: '0 2px',
				background: 'transparent',
				font: 'inherit',
				fontSize: 12,
				color: tokens.text.muted,
				cursor: 'pointer',
			}}
		>
			{unit.options.map(option => (
				<option key={option.value} value={option.value}>{option.label}</option>
			))}
		</select>
	);

	return (
		<>
			{slot && ReactDOM.createPortal(unitSelect, slot)}

			<Segmented
				block
				value={selected}
				onChange={value => onChange(value as number)}
				options={options}
			/>
		</>
	);
}
